export const theme = {

  // basic colors
  white: '#ffffff',
  black: '#000000',
  red: 'red',
  black_12: 'rgba(0, 0, 0, 0.12)',
  black_38: 'rgba(0, 0, 0, 0.38)',
  black_60: 'rgba(0, 0, 0, 0.6)',
  black_87: 'rgba(0, 0, 0, 0.87)',
  gray: '#aaa',

  // backgroundColor
  themePrimaryLighter: '#4b5ca3',
  themePrimaryDarker: '#000e48',
  userManageEditUserModalStatusBadgeBackgroundColor: '#D6F8C5',
  fsItemListProgressBgColor: '#EDEBE9',
  clusterReportBgColor: 'rgb(251, 251, 251)',
  versionLogBgColor: '#FBFBFB',

  // Header
  themePageHeaderPrimary: '#143374',
  themePageHeaderPrimaryHover: '#000E48',

  // Guide Page
  maskColor: 'rgba(0, 0, 0, 0.3)',

  // donut, running machine
  donutRed: '#F44336',
  donutOrange: '#FFC107',
  donutGreen: '#19BB7B',

  // border
  borderLineColor: 'rgba(0, 0, 0, 0.12)',
  scheduleBorderColor: '#EAEAEA',
  mirrorDividerColor: '#c4c4c4',
  step5PreviewModalNFSBorderColor: '#B55108',
  step5PreviewModalGlusterFSBorderColor: '#FF7C43',
  step5PreviewModalRDMABorderColor: '#0793D1',
  step5PreviewModalWithoutRDMABorderColor: '#A19F9D',
  storageChartChartBeforeBorderColor: 'rgba(211, 211, 211, .3)',
  groupManageMemberEditModalBorderColor: 'rgba(0,0,0,0.12)',

  // button
  themeDenied: '#C33E38',
  themePending: '#DE722D',
  themePermitted: '#457A3B',
  themePrimary: '#143374',
  themePrimaryHover: '#000E48',
  themePrimaryLightBg: 'rgba(191, 199, 222, 1)',
  themeDisablePrimaryBackground: 'rgba(0, 0, 0, 0.12)',
  themeDisablePrimaryColor: 'rgba(0, 0, 0, 0.38)',
  themeDefaultBorderColor: '#8A8886',
  themeDefaultBackgroundFocus: '#F5F5F5',
  themeDefaultBackgroundHover: '#F5F5F5',

  themeDenyDefaultBackgroundColor: '#DD4B39',
  themeDenyDefaultBackgroundColorHover: '#C84534',

  // progress
  progressRed: '#F44336',
  progressOrange: '#FFC107',
  progressGreen: '#19BB7B',

  // Home page pie
  pieStop: '#9E9E9E',
  pieStopping: '#BDBDBD',
  pieWait: '#FFC107',
  pieFail: '#F44336',
  pieRuning: '#2196F3',
  pieSuccess: '#19BB7B',

  // Home page Icon
  runningJobsIconColor: '#2196F3',
  stopJobsIconColor: '#9E9E9E',
  failJobsIconColor: '#F44336',

  // Home page progress
  progressMemory: '#9c28b0',
  progressCPU: '#2296f3',
  progressGPU: '#17bb7c',
  progressGPUMemoryPercentage: '#DD5282',

  gpuUtilRateDonutColor: [
    '#4C9D5D',
    '#7AB365',
    '#A6C870',
    '#D2DC7F',
    '#FFF092',
    '#FDCF73',
    '#F8AC5E',
    '#F18952',
    '#E5644F',
    '#DE425B'
  ],

  hightLightPrimary: '#E6F7EF',

  neutralPrimary: '#323130',

  others: {
    monacoColor: '#a19f9d',
    themeContentBgColor: '#ecf0f5',
    clickableLineBg: 'rgba(20, 51, 116, 0.04)',
    resourceManageSubsourceGroupTooltipBgColor: '#E6E9F1'
  },

  defaultChartTrailColor: '#0000001F',
  trans: 'transparent',

  // ViewSchedule
  states: {
    denied: '#FFE4DD',
    verifying: '#FFF8EA',
    verified: '#D6F8C5'
  },
  infos: {
    green: 'green',
    red: 'red',
    state: 'FFA500',
    orange: 'orange'
  },
  denyColor: {
    normal: '#DD4B39',
    hover: '#c13f2f'
  },

  // ManageReserve
  reserve: {
    waiting: {
      bg: '#E3F2FD',
      text: '#1565C0'
    }
  },

  // Components
  baseTextBadgeBgColor: 'rgba(230, 233, 241, 1)'
}

export default theme;
